import React from 'react';
import { toast } from 'react-toastify';

import { TOASTR_OPTIONS } from '../utils/constants';

function ToastrComponent({ message }) {
  return (
    <div className="flex flex-row items-start justify-start">
      <p className="mx-4 font-medium leading-5 text-white">{message}</p>
    </div>
  );
}

const showToastr = (message) => toast.success(<ToastrComponent message={message} />, TOASTR_OPTIONS);
const showInfoToastr = (message) => toast.warning(<ToastrComponent message={message} />, TOASTR_OPTIONS);
const showWarningToastr = (warning) => toast.warning(<ToastrComponent message={warning} />, TOASTR_OPTIONS);

const isError = (e) => e && e.stack && e.message;

const showErrorToastr = (error) => {
  const errorMessage = isError(error) ? error.message : error;
  toast.error(<ToastrComponent message={errorMessage} />, TOASTR_OPTIONS);
};

export const Toastr = {
  success: showToastr,
  error: showErrorToastr,
  info: showInfoToastr,
  warning: showWarningToastr,
};

export default Toastr;
